import React, { Component } from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import Button from "@material-ui/core/Button/Button"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import AddOutlined from "@material-ui/icons/AddOutlined"
import FileLoader from "../../../../../../components/formComponents/fileLoader"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import {
  FormDatePicker,
  MultipleTextField,
} from "../../../../../../components/formComponents"
import { urlValidation } from "../../../../../../library/utils/validators"
import { call } from "../../../../../../library/networking/API"
import { FRIENDS } from "../../../../../../library/store/actions/types/friendsTypes"
import Loader from "../../../../../../components/ui/loader"
import {
  createCalendarEvent,
  getCalendarEvent,
  getCalendarEventsList,
  updateCalendarEvent,
} from "../../../../../../library/store/actions/creators/calendarCreators"

import UsersPicker from "../../../../../../components/formComponents/usersPicker/usersPicker"
import DeleteForeverOutlined from "@material-ui/icons/DeleteForeverOutlined"
import Checkbox from "@material-ui/core/Checkbox/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel"
import getErrorText from "../../../../../../library/constants/errorTypes"
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons"
import { calendarEventsColors } from "../../../../../../library/constants/calendar"

class EventFormModal extends Component {
  state = {
    title: "",
    description: "",
    links: [],
    attachments: [],
    date_from: this.props.chosenTime.date_from || null,
    date_to: this.props.chosenTime.date_to || null,
    dateFromError: false,
    dateToError: false,
    allDay: false,
    is_holiday: false,
    openUsersListDialog: false,
    usersList: [],
    color: calendarEventsColors[0].hex,
    dataReceived: false,
    recurring: false,
  }

  async componentDidMount() {
    ValidatorForm.addValidationRule("isLink", (value) => urlValidation(value))

    console.log(this.props)
    if (this.props.edit) {
      await this.props.getCalendarEvent({ id: this.props.activeEvent })

      this.setState({
        title: this.props.calendar.currentEvent.name || "",
        description: this.props.calendar.currentEvent.description || "",
        links: this.props.calendar.currentEvent.links || [],
        attachments: this.props.calendar.currentEvent.blobs || [],
        date_from: this.props.calendar.currentEvent.date_from || null,
        date_to: this.props.calendar.currentEvent.date_to || null,
        all_day: this.props.calendar.currentEvent.all_day || false,
        recurring: this.props.calendar.currentEvent.recurring || false,
        color: this.props.calendar.currentEvent.color || "",
        usersList: this.props.calendar.currentEvent.participants || [],
        is_holiday: this.props.calendar.currentEvent.is_holiday || false,
      })
    }

    this.setState({ dataReceived: true })
  }

  getUsers = async (name, offset = 0) => {
    const usersResponse = await call(FRIENDS.LIST, {
      token: this.props.auth.userData.token,
      user_id: this.props.auth.userData.id,
      name: name || undefined,
      offset: offset,
      limit: 30,
    })
    return await usersResponse.data.users
  }

  openUsersDialog = () => this.setState({ openUsersListDialog: true })

  closeUsersDialog = () => this.setState({ openUsersListDialog: false })

  addUser = (user) => {
    console.log("add", user)
    this.setState((prevState) => {
      return {
        usersList: [...prevState.usersList, user],
      }
    })
  }

  deleteUserFromList = (user_id) => {
    console.log("delete", user_id)
    this.setState((prevState) => ({
      usersList: prevState.usersList.filter((u) => u.id !== user_id),
    }))
  }

  handleChange = (name) => (event) => {
    if (name === "allDay" || name === "is_holiday") {
      this.setState({
        [name]: event.target.checked,
      })
    } else {
      this.setState({
        [name]: event.target.value,
      })
    }
  }

  handleChangeDate = (name, date) => {
    this.setState({ [name]: date })

    switch (name) {
      case "date_from":
        return this.setState({ dateFromError: !date })

      case "date_to":
        return this.setState({ dateToError: !date })

      default:
        return this.setState({ [name]: date })
    }
  }

  handleFileInputOpen = () => {
    document.getElementById("attachments").click()
  }

  setAttachments = ({ blobs }) => {
    this.setState({ attachments: blobs })
  }

  validateForm = () => {}

  processEventCreate = async () => {
    const {
      title,
      links,
      date_to,
      date_from,
      description,
      attachments,
      allDay,
      is_holiday,
      usersList,
      color,
      recurring,
    } = this.state

    const dates = !allDay
      ? {
          date_from,
          date_to,
        }
      : {
          date_from: new Date(
            new Date(date_from).setHours(0, 0, 1)
          ).toISOString(),
          date_to: new Date(
            new Date(date_from).setHours(23, 59, 59)
          ).toISOString(),
        }

    const data = {
      id: this.props.edit ? this.props.calendar.currentEvent.id : undefined,
      name: title,
      description,
      is_all_day: allDay,
      ...dates,
      links,
      participants: usersList.map((u) => u.id),
      attachments: attachments.map((a) => a.id),
      // color: calendarEventsColors.find((c) => c.hex === color).rgba,
      color,
      // recurring,
      is_holiday,
      isAppointment: !this.props.groupId,
    }

    try {
      if (this.props.edit) {
        await this.props.updateCalendarEvent(data)
      } else {
        await this.props.createCalendarEvent({
          group_id: this.props.groupId,
          ...data,
        })
      }

      await this.props.getCalendarEventsList({
        group_id: this.props.groupId,
        ...this.props.activeRange,
      })
      this.props.onSubmit()
      this.props.handleClose()
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  render() {
    const {
      handleClose,
      open,
      auth: { userData },
    } = this.props
    const {
      title,
      description,
      allDay,
      links,
      attachments,
      date_from,
      date_to,
      dateFromError,
      dateToError,
      dataReceived,
      usersList,
      recurring,
      is_holiday,
    } = this.state

    return (
      <>
        <Dialog
          aria-labelledby="event-form-dialog"
          onClose={handleClose}
          open={open}
          maxWidth="md"
        >
          <ValidatorForm onSubmit={this.processEventCreate}>
            <DialogTitle id="alert-dialog-title" className="text-center">
              {this.props.edit ? "Edit appointment" : "Create appointment"}
            </DialogTitle>
            <DialogContent>
              {dataReceived ? (
                <div className="f jcc">
                  <div className="form form--modal">
                    <div className="form__fieldset">
                      <label htmlFor="title" className="form__label">
                        Title *
                      </label>
                      <div className="form__fieldbox">
                        <div className="form__input">
                          <TextValidator
                            id="title"
                            name="title"
                            value={title}
                            placeholder="Type appointment title"
                            className="edit-form__input"
                            margin="normal"
                            fullWidth
                            validators={[
                              "required",
                              "minStringLength:3",
                              "maxStringLength:200",
                            ]}
                            errorMessages={[
                              "Field is required",
                              "Min length is 3 characters",
                              "Max length is 200 characters",
                            ]}
                            withRequiredValidator
                            onChange={this.handleChange("title")}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form__fieldset">
                      <span className="form__label">Guests</span>
                      <div className="form__fieldbox" style={{ width: 330 }}>
                        {this.state.usersList.map((user) => (
                          <div
                            className="form__controllable-input pt10"
                            key={user.id}
                          >
                            <div className="form__input">
                              <span className="color-primary">
                                {user.first_name + " " + user.last_name}
                              </span>
                            </div>
                            <button
                              className="form__manage-input"
                              type="button"
                              onClick={() => this.deleteUserFromList(user.id)}
                            >
                              <DeleteForeverOutlined /> Delete
                            </button>
                          </div>
                        ))}

                        {this.state.usersList.length < 100 && (
                          <button
                            className="form__add-input"
                            type="button"
                            onClick={this.openUsersDialog}
                          >
                            <AddOutlined /> Add guest
                          </button>
                        )}
                      </div>
                    </div>

                    <FormDatePicker
                      withTimePicker={!allDay}
                      // minDate={}
                      maxDate={new Date().setFullYear(
                        new Date().getFullYear() + 1,
                        11,
                        31
                      )}
                      dateFrom={{
                        label: "Start date",
                        value: date_from,
                        minDate: new Date().setFullYear(
                          new Date().getFullYear(),
                          0,
                          1
                        ),
                        required: true,
                        error: dateFromError,
                        handleChange: (value) =>
                          this.handleChangeDate("date_from", value),
                      }}
                      dateTo={
                        !allDay
                          ? {
                              label: "End date",
                              value: date_to,
                              required: true,
                              error: dateToError,
                              handleChange: (value) =>
                                this.handleChangeDate("date_to", value),
                            }
                          : undefined
                      }
                    />

                    <div className="form__fieldset">
                      <span className="form__label"></span>
                      <div className="form__fieldbox">
                        <div className="form__input">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={allDay}
                                value={"allDay"}
                                disableRipple
                                onChange={this.handleChange("allDay")}
                              />
                            }
                            label="All day"
                          />
                        </div>
                      </div>
                    </div>

                    {!!this.props.groupId && (
                      <div className="form__fieldset">
                        <span className="form__label"></span>
                        <div className="form__fieldbox">
                          <div className="form__input">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={is_holiday}
                                  value={"is_holiday"}
                                  disableRipple
                                  onChange={this.handleChange("is_holiday")}
                                />
                              }
                              label="Mark as holiday(s)"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/*<div className="form__fieldset">*/}
                    {/*  <span className="form__label"></span>*/}
                    {/*  <div className="form__fieldbox">*/}
                    {/*    <div className="form__input">*/}
                    {/*      <FormControlLabel*/}
                    {/*        control={*/}
                    {/*          <Checkbox*/}
                    {/*            checked={recurring}*/}
                    {/*            value={'recurring'}*/}
                    {/*            disableRipple*/}
                    {/*            onChange={this.handleChange('recurring')}*/}
                    {/*          />*/}
                    {/*        }*/}
                    {/*        label="Repeat each week"*/}
                    {/*      />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*</div>*/}

                    <div className="form__fieldset">
                      <label htmlFor="description" className="form__label">
                        Description *
                      </label>
                      <div className="form__fieldbox">
                        <div className="form__input">
                          <TextValidator
                            id="description"
                            name="description"
                            value={description}
                            placeholder="Type appointment description"
                            className="edit-form__input"
                            margin="normal"
                            fullWidth
                            validators={["required", "maxStringLength:500"]}
                            errorMessages={[
                              "Field is required",
                              "Max length is 500 characters",
                            ]}
                            onChange={this.handleChange("description")}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form__fieldset">
                      <span className="form__label">Color</span>
                      <div className="form__fieldbox">
                        <div className="f" style={{ width: 330 }}>
                          {calendarEventsColors.map((color) => (
                            <div className="f" key={color.hex}>
                              {this.state.color !== color.hex ? (
                                <CheckBoxOutlineBlank
                                  style={{ color: color.hex }}
                                  className="pointer"
                                  onClick={() =>
                                    this.setState({ color: color.hex })
                                  }
                                />
                              ) : (
                                <CheckBox
                                  style={{ color: color.hex }}
                                  className="pointer"
                                  onClick={() => this.setState({ color: "" })}
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <MultipleTextField
                      formIsModal
                      values={links}
                      setValues={(links) =>
                        this.setState({ links }, () => console.log(this.state))
                      }
                      limit={10}
                      fieldLabel="Links"
                      fieldPlaceholder="Type URL"
                      addButtonLabel="Add link"
                      validators={["isLink", "maxStringLength:250"]}
                      validatorMessages={[
                        "Invalid URL",
                        "Max length is 250 characters",
                      ]}
                    />

                    <div className="form__fieldset">
                      <span className="form__label">Attachments</span>
                      <div className="form__fieldbox">
                        <div className="form__attachments">
                          <FileLoader
                            attachmentId={"attachments"}
                            blobs={attachments}
                            onUpload={this.setAttachments}
                            token={userData.token}
                            attachmentOnly={true}
                            limit={10}
                          />
                          <button
                            className="form__add-input"
                            type="button"
                            onClick={this.handleFileInputOpen}
                          >
                            <AddOutlined /> Add attachment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button type="submit" color="primary" onClick={this.validateForm}>
                Save
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
        {this.state.openUsersListDialog && (
          <UsersPicker
            open={this.state.openUsersListDialog}
            handleClose={this.closeUsersDialog}
            getUsers={this.getUsers}
            addUser={this.addUser}
            deleteUser={this.deleteUserFromList}
            chosenUsers={this.state.usersList}
            limit={100}
          />
        )}
      </>
    )
  }
}

const mapStateToProps = ({ auth, groups, calendar }) => ({
  auth,
  groups,
  calendar,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCalendarEvent,
      createCalendarEvent,
      updateCalendarEvent,
      getCalendarEventsList,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(EventFormModal))
